import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import SectionTitle from '@/components/SectionTitle'
import { WidgetContentPropType } from '@/propTypes'

import Item from '@/features/landing/components/WhyProkit/Item'

import Container from './style'

interface Props {
  items: WidgetContentInterface[]
  style?: CSSProperties
  className?: string
  id?: string
}

function WhyProKit({ id, className, style, items }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="container">
        <SectionTitle className="title">
          <span>
            ทำไมต้อง PDPA&nbsp;<span className="primary">PROKIT</span>
          </span>
        </SectionTitle>
        <section className="grid-container">
          {items.map((item: WidgetContentInterface) => (
            <Item key={item.title} symbol={item.symbol} title={item.title}>
              {item.content}
            </Item>
          ))}
        </section>
      </div>
    </Container>
  )
}

WhyProKit.propTypes = {
  items: PropTypes.arrayOf(WidgetContentPropType),
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

WhyProKit.defaultProps = {
  className: '',
}

export default memo(WhyProKit)
